import { render, staticRenderFns } from "./VolumeOff.vue?vue&type=template&id=4a067b0e"
import script from "./VolumeOff.vue?vue&type=script&lang=js"
export * from "./VolumeOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports